<template lang="html">
  <article class="" v-if="isLoaded" >

    <div class="offer_elements__condition--action_row">
      <p class="accessIndex__text--title_clean" >Ver segmento</p>
      <v-hover>
          <div slot-scope="{ hover }" @click="editCondition()" :class="hover?'agreement__interaction--hover':''" class="agreement__buttons--create_new_v2">
            <p>Editar</p>
          </div>
        </v-hover>
    </div>
    <div >
      <label @click="$router.push({name: 'condition'})" class="accessIndex__text--normal_user_gray">Segmentos</label>
      <label class="accessIndex__text--normal_user_separator"> > </label>
      <label class="accessIndex__text--normal_user">Ver segmento</label>
    </div>

    <section v-if="charged">

      <div class="offer_elements__condition--new_info_container">
      <p class="agreement__text--small_gray">Descripción</p>
      <v-text-field
        single-line
        name="name"
        label="Descripción del segmento"
        type="text"
        v-model="condition.attributes.description"></v-text-field>


      <!-- <v-flex xs12>
        <v-btn
          color="#EC7E00"
          dark
          @click="addRequirement()">Agregar requerimiento</v-btn>
      </v-flex> -->
      <div class="offer_elements__condition--element_container">
        <div :class="index<2?'offer_elements__condition--requirement':'offer_elements__condition--requirement_blue'" v-if="(requirement.id==undefined||requirement.id==null)||(requirement.id!=undefined&&(requirement._destroy==undefined||requirement._destroy==null))" v-for="(requirement, index) in requirements">
          <p class="agreement__text--small_gray">Requerimiento</p>

          <div class="offer_elements__condition--action_row_requirement">
            <div class="dashboard__options--input with_box_shadow offer_elements__condition--select"
              @click="requirement.modal=!requirement.modal">
              <p >{{requirement.selectedOption!=''?requirement.selectedOption:'Selecciona'}}</p>
              <img  src="https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_down.svg">
              <div v-if="requirement.modal&&(requirement.id==undefined||requirement.id==null)" class="offer_elements__condition--options">
                <template v-for="option in requirement.options">
                  <v-hover>
                    <div slot-scope="{ hover }" @click="changeBooleanState(index,option)" :class="hover?'offer_elements__interaction--hover':''" class="offer_elements__condition--options_item" >
                      <p >{{option.text}}</p >
                    </div>
                  </v-hover>
                </template>
              </div>
            </div>

            <!-- <v-hover>
              <button  @click="removeRequirement(index)" slot-scope="{ hover }" :class="hover?'offer_elements__interaction--hover_delete':''" class="offer_elements__button--add_requirement with_box_shadow offer_elements__interaction--border_gray">
                <div class="offer_elements__button--delete_requirement " :class="hover?'offer_elements__interaction--hover_delete_background':''">
                  <p>x</p>
                </div>
              </button>
            </v-hover> -->
          </div>
          <!-- <v-switch
            :label="`¿Es un requerimiento por visitas?: ${requirement.requirement_query ? 'Si' : 'No'}`"
            v-model="requirement.requirement_query"
            v-if="requirement.requirement_query ||
                  (requirement.requirement_range == false &&
                   requirement.requirement_email == false &&
                   requirement.requirement_register == false &&
                   requirement.requirement_birthday == false &&
                   requirement.requirement_redemption == false)"
          ></v-switch> -->

            <v-flex xs12 sm12 v-if="requirement.requirement_query">
              <p class="agreement__text--small_gray">Descripción</p>
                <v-text-field
                  single-line
                  name="name"
                  label="Descripción del requerimiento"
                  type="text"
                  :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"
                  v-model="requirement.query_attributes.attribute_json.description"></v-text-field>

              <p class="agreement__text--small_gray">Tipo de modelo</p>
              <v-select
              :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"
                v-model="requirement.query_attributes.attribute_json.object_type"
                :items="requirement.query_types"
                item-text="text"
                item-value="type"
                label="Tipo de modelo"
                persistent-hint
                return-object
                single-line
                @change="findObjects(index)"
              ></v-select>

              <v-flex xs12>
                <v-switch
                  :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"
                  :label="`¿Tiene una localidad en específico?: ${requirement.query_attributes.attribute_json.object_type=='Location'&& requirement.query_attributes.attribute_json.object_id? 'Si' : 'No'}`"
                  v-model="requirement.query_attributes.attribute_json.object_id!=null"
                  v-if="requirement.query_attributes.attribute_json.object_type =='Location'"
                ></v-switch>

                <template v-if="(requirement.query_attributes.attribute_json.object_type == 'Offer'||requirement.query_attributes.attribute_json.object_type =='Location')&&requirement.query_attributes.attribute_json.object_id!=null">
                  <p class="agreement__text--small_gray">Opciones</p>
                  <!-- <v-select
                    :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"
                    :v-model="mySelectedOption(requirement)"                    
                    label="Tipo de modelo"
                    persistent-hint
                    return-object
                    single-line
                  ></v-select> -->
                   <v-text-field
                    :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"
                    name="Tipo de modelo"
                    label="Tipo de modelo"
                    single-line
                    :value="mySelectedOption(requirement)"></v-text-field>
                </template>
              </v-flex>
              <p class="agreement__text--small_gray">Visitas</p>
              <v-text-field
                :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"

                name="visits"
                label="Visitas a la instancia del modelo"
                type="number"
                single-line
                v-model="requirement.query_attributes.attribute_json.times"></v-text-field>

            </v-flex>

            <!-- <v-switch
              :label="`¿Incluir un requerimiento por rango?: ${requirement.requirement_range ? 'Si' : 'No' }`"
              v-model="requirement.requirement_range"
              v-if="requirement.requirement_range ||
                    (requirement.requirement_query == false &&
                     requirement.requirement_email == false &&
                     requirement.requirement_register == false &&
                     requirement.requirement_birthday == false &&
                     requirement.requirement_redemption == false)"
            ></v-switch> -->
            <v-flex xs12 v-if="requirement.requirement_range">
              <p class="agreement__text--small_gray">Descripción</p>
              <v-text-field
              :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"
                name="name"
                label="Descripción del requerimiento"
                type="text"
                single-line
                v-model="requirement.range_attributes.attribute_json.description">
                </v-text-field>


              <v-flex xs12>
                <p class="agreement__text--small_gray">Opción</p>
                <v-select


                  v-model="requirement.range_attributes.attribute_json.attribute_name"
                  :items="requirement.range_type_attribute"
                  item-text="text"
                  item-value="attribute"
                  :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"
                  label="Nombre de atributo del cliente"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
              </v-flex>
              <v-layout xs12 row wrap>
                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="requirement.range_attributes.attribute_json.attribute_name != ''">
                  <p class="agreement__text--small_gray">Desde</p>
                  <v-text-field
                    :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"
                    name="number"
                    label=""
                    type="number"
                    v-model="requirement.range_attributes.attribute_json.lower_bound"
                    v-if="requirement.range_attributes.attribute_json.attribute_name.attribute == 'age'"></v-text-field>
                    <v-menu
                      v-model="requirement.requirement_date_menu"
                      :nudge-bottom="10"
                      lazy
                      transition="scale-transition"
                      offset-y
                      :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"
                      full-width
                      min-width="290px"
                      v-else-if="requirement.range_attributes.attribute_json.attribute_name.attribute == 'created_at' || requirement.range_attributes.attribute_json.attribute_name.attribute == 'updated_at'"
                      >
                      <template v-slot:activator="{ on }">
                        <div  class="date_picker__selector--invitation" v-on="on" >
                          <p >{{requirement.range_attributes.attribute_json.lower_bound!=null?requirement.range_attributes.attribute_json.lower_bound:'Seleccione una fecha'}}</p>
                          <img :src="requirement.requirement_date_menu ?'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_up.svg':'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_down.svg'">
                        </div>
                      </template>
                      <v-date-picker
                        v-model="requirement.range_attributes.attribute_json.lower_bound"
                        locale="es"
                        color="#EC7E00"
                        scrollable
                        ></v-date-picker>
                    </v-menu>


                </v-flex>
                <v-flex
                  xs6
                  style="padding: 8px; "
                  v-if="requirement.range_attributes.attribute_json.attribute_name != ''">
                  <p class="agreement__text--small_gray">Hasta</p>
                  <v-text-field
                    name="number"
                      :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"

                    label=""
                    type="number"
                    v-model="requirement.range_attributes.attribute_json.upper_bound"
                    v-if="requirement.range_attributes.attribute_json.attribute_name.attribute == 'age'"></v-text-field>
                    <v-menu
                    :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"
                      v-model="requirement.requirement_date_menu2"
                      :nudge-bottom="10"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      v-else-if="requirement.range_attributes.attribute_json.attribute_name.attribute == 'created_at' || requirement.range_attributes.attribute_json.attribute_name.attribute == 'updated_at'"
                      >
                      <template v-slot:activator="{ on }">
                        <div  class="date_picker__selector--invitation" v-on="on" >
                          <p >{{requirement.range_attributes.attribute_json.upper_bound!=null?requirement.range_attributes.attribute_json.upper_bound:'Seleccione una fecha'}}</p>
                          <img :src="requirement.requirement_date_menu2 ?'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_up.svg':'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_down.svg'">
                        </div>
                      </template>
                      <v-date-picker
                        v-model="requirement.range_attributes.attribute_json.upper_bound"
                        locale="es"
                        color="#EC7E00"
                        scrollable
                        ></v-date-picker>
                    </v-menu>


                </v-flex>
              </v-layout>
            </v-flex>

            <!-- <v-switch
              :label="`¿Es un requerimiento con emails?: ${requirement.requirement_email ? 'Si' : 'No' }`"
              v-model="requirement.requirement_email"
              v-if="requirement.requirement_email ||
                    (requirement.requirement_query == false &&
                     requirement.requirement_range == false &&
                     requirement.requirement_register == false &&
                     requirement.requirement_birthday == false &&
                     requirement.requirement_redemption == false)"
            ></v-switch> -->
            <v-flex xs12 v-if="requirement.requirement_email">
              <p class="agreement__text--small_gray">Emails</p>
              <v-text-field
                name="emails"
                  :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"

                label="Ingrese los emails, separados por comas"
                type="text"
                single-line
                v-model="requirement.email_attributes.attribute_json.emails"></v-text-field>
            </v-flex>

            <!-- <v-switch
              :label="`¿Es un requerimiento por registro?: ${requirement.requirement_register ? 'Si' : 'No' }`"
              v-model="requirement.requirement_register"
              v-if="requirement.requirement_register ||
                    (requirement.requirement_query == false &&
                     requirement.requirement_range == false &&
                     requirement.requirement_email == false &&
                     requirement.requirement_birthday == false &&
                     requirement.requirement_redemption == false)"
            ></v-switch> -->
            <v-flex xs12 v-if="requirement.requirement_register">
            </v-flex>

            <!-- <v-switch
              :label="`¿Es un requerimiento por cumpleaños?: ${requirement.requirement_birthday ? 'Si' : 'No' }`"
              v-model="requirement.requirement_birthday"
              v-if="requirement.requirement_birthday ||
                    (requirement.requirement_query == false &&
                     requirement.requirement_range == false &&
                     requirement.requirement_email == false &&
                     requirement.requirement_register == false &&
                     requirement.requirement_redemption == false)"
            ></v-switch> -->
            <v-flex xs12 sm12  v-if="requirement.requirement_birthday">
              <p class="agreement__text--small_gray">Seleccione el mes </p>
              <v-select
                :items="months"
                :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"

                v-model="requirement.birthday_attributes.attribute_json.value"
                single-line
                label="Selecciona el mes de cumpleaños"
              ></v-select>
            </v-flex>
            <!-- <v-switch
              :label="`¿Es un requerimiento por canje de ofertas?: ${requirement.requirement_redemption ? 'Si' : 'No'}`"
              v-model="requirement.requirement_redemption"
              v-if="requirement.requirement_redemption ||
                    (requirement.requirement_query == false &&
                     requirement.requirement_range == false &&
                     requirement.requirement_email == false &&
                     requirement.requirement_register == false &&
                     requirement.requirement_birthday == false)"
            ></v-switch> -->
            <v-flex xs12 sm12 v-if="requirement.requirement_redemption">
              <v-flex xs12>
                <p class="agreement__text--small_gray">Descripción</p>
                <v-text-field
                  :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"

                  name="name"
                  label="Descripción del requerimiento"
                  type="text"
                  single-line
                  v-model="requirement.redemption_attributes.attribute_json.description"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <p class="agreement__text--small_gray">Nombre de la oferta</p>
                <v-select
                  :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"
                  :value="mySelectedOffer(requirement)"
                  :items="requirement.redemption_offers_options"
                  item-text="attributes.title"
                  label="Oferta a canjear"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <p class="agreement__text--small_gray">Número de canjes</p>
                <v-text-field
                  :disabled="(requirement.id!=undefined&&requirement.id!=null)?true:false"
                  name="visits"
                  label="Número de canjes de la oferta"
                  type="number"
                  single-line

                  v-model="requirement.redemption_attributes.attribute_json.times"></v-text-field>
              </v-flex>
            </v-flex>

            <v-flex xs12 sm12 v-if="requirement.requirement_characteristic">
              <v-flex xs12>

                <p class="agreement__text--small_gray">Nombre de la característica</p>

                <v-select
                  :placeholder="requirement.characteristic_attributes.segment_value"
                  :items="requirement.characteristic_options"
                  item-text="name"
                  label="Nombre de la característica"
                  persistent-hint
                  return-object
                  single-line
                  disabled
                ></v-select>
              </v-flex>
            <v-flex xs12>

              <p class="agreement__text--small_gray">Valor de la característica</p>
              <v-select
                :placeholder="requirement.characteristic_attributes.attribute_json.characteristic_value"
                label="Valor de la característica"
                persistent-hint
                return-object
                single-line
                disabled
              ></v-select>
            </v-flex>

            <v-flex xs12 v-if="requirement.characteristic_attributes.attribute_json.characteristic_value && requirement.characteristic_attributes.attribute_json.characteristic_value=='Característica personalizada'">
              <p class="agreement__text--small_gray">Rango de valores personalizados</p>
              <v-card-text  style="margin-top:-21px;">
                <v-flex style="display:flex;">
                  <p class="data_card__info--title" style="font-size:12px;margin-top:16px;width:60px;padding:12px;height:fit-content;padding-right:0px;margin-left:10px">Desde</p>
                  <v-flex class="px-2"></v-flex>
                  <p class="data_card__info--title" style="font-size:12px;margin-top:16px;width:fit-content;padding:12px;height:fit-content; padding-right:50px; ">Hasta</p>
                </v-flex>
                <v-layout >
                  <v-flex class="px-4" style="margin-top:-21px;">
                    <v-range-slider
                      v-model="requirement.characteristic_attributes.attribute_json.custom_querry"
                      
                      hide-details
                      class="align-center"
                      thumb-label
                      ticks
                      type="decimal"
                      disabled
                    >
                      <template v-slot:prepend>
                        <v-text-field
                          v-model="requirement.characteristic_attributes.attribute_json.custom_querry[0]"
                          class="mt-0 pt-0"
                          hide-details
                          single-line
                          type="float"
                          step="0.01"
                          style="width: 60px"
                          disabled
                        ></v-text-field>
                      </template>
                      <template v-slot:append>
                        <v-text-field
                          v-model="requirement.characteristic_attributes.attribute_json.custom_querry[1]"
                          disabled
                          class="mt-0 pt-0"
                          hide-details
                          single-line
                          type="float"
                          step="0.01"
                          style="width: 60px"
                        ></v-text-field>
                      </template>
                    </v-range-slider>
                  </v-flex>

                </v-layout>
              </v-card-text>
            </v-flex>
          </v-flex>
          <v-spacer></v-spacer>
          <!-- <v-layout align-center justify-end row fill-height>
            <v-btn
              color="red lighten-1"
              dark
              @click="removeRequirement(index)">Eliminar Requerimiento</v-btn>
          </v-layout> -->
        </div>
        <!-- <v-flex xs6>
          <p class="agreement__text--small_gray ">Requerimiento</p>
          <div class="offer_elements__condition--add_container  ">
            <v-hover>
                <button @click="addRequirement(false)" slot-scope="{ hover }" :class="hover?'accessIndex__interaction--hover_add':''" class="offer_elements__button--add_requirement with_box_shadow offer_elements__interaction--border_blue">
                  <p>+</p>
                </button>
            </v-hover>
          </div>
      </v-flex > -->

      </div>


      </div>
    </section>

  </article>
</template>

<script>
export default {
  data() {
    return {
      condition: {
        attributes: {
          description: "",
          frequent: true,
          requirements_attributes: [],
          company_id: this.getCompany().id,
        },
      },
      months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      current_requirements: [],
      requirements: [],
      myCharacteristicsOptions: [],
      charged: false,
      myRequirements: [],
      myIndexCharacteristic: 0,
      isLoaded: false,
    };
  },
  mounted() {
    var self = this;
    this.findCategories();
    this.findLocations();
    this.findOffers();
    this.locations = this.getLocations();
    var path = this.$route.path.split("/");
    try {
      this.$http
        .get("conditions/" + path[2], {
          headers: {
            "X-Device-ID": this.getDeviceId(),
            Authorization: "Bearer " + this.getUserToken(),
          },
        })
        .then(
          function (response) {
            this.condition = response.body.data;
            this.current_requirements = response.body.included;
            this.myRequirements =
              response.body.data.attributes.current_requirements;
            this.addRequirement(true);
            this.isLoaded = true;
            if (response.body.meta != undefined && response.body.meta != null) {
              if (
                response.body.meta.authentication_token != undefined &&
                response.body.meta.authentication_token != null
              ) {
                this.checkToken(response.body.meta.authentication_token);
              }
            }
          },
          function (response) {
            if (response.body.meta != undefined && response.body.meta != null) {
              if (
                response.body.meta.authentication_token != undefined &&
                response.body.meta.authentication_token != null
              ) {
                this.checkToken(response.body.meta.authentication_token);
              }
            }
            if (typeof response.body.errors[0].details != "object") {
              alert(response.body.errors[0].details);
            } else {
              let message = [];
              for (var key in response.body.errors[0].details) {
                message.push(response.body.errors[0].details[key]);
              }
              alert(message);
            }
          }
        );
    } catch (e) {
      alert(e.message);
    }
  },
  methods: {
    sliderStep(myNumber) {
      var ans = 0;
      if (myNumber <= 10) {
        ans = 0.01;
      } else if (myNumber < 50) {
        ans = 0.1;
      } else {
        ans = 1;
      }
      return ans;
    },
    mySelectedOffer(requirement) {
      let object_index =
        requirement.redemption_attributes.attribute_json.object_id;

      let selected = requirement.redemption_offers_options
        .map(function (x) {
          return x.id;
        })
        .indexOf(object_index);
      return requirement.redemption_offers_options[selected].attributes.title;
    },
    mySelectedOption(requirement) {
      if (requirement.query_attributes.attribute_json.object_type == "Offer") {
        let object_index =
          requirement.query_attributes.attribute_json.object_id;
        let selected = requirement.redemption_offers_options
          .map(function (x) {
            return x.id;
          })
          .indexOf(object_index);

        return requirement.redemption_offers_options[selected].attributes.title;
      } else if (
        requirement.query_attributes.attribute_json.object_type == "Location"
      ) {
        let object_index =
          requirement.query_attributes.attribute_json.object_id;
        let selected = this.locations
          .map(function (x) {
            return x.id;
          })
          .indexOf(object_index);
        return this.locations[selected].attributes.title;
      }
    },
    removeRequirement(index) {
      if (
        this.requirements[index].id != null &&
        this.requirements[index].id != undefined
      ) {
        var delete_object = {
          id: this.requirements[index].id,
          _destroy: this.requirements[index].id,
        };
        this.requirements.splice(index, 1);
        this.requirements.push(delete_object);
      } else {
        this.requirements.splice(index, 1);
      }
    },
    // deleteRequirement(index){
    //   if(this.current_requirements[index].id != undefined && this.current_requirements[index].id != null){
    //     this.current_requirements[index]._destroy = this.current_requirements[index].id
    //     this.requirements.push({id: this.current_requirements[index].id, _destroy: this.current_requirements[index]._destroy})
    //   }
    // },
    addRequirement(oldRequirements) {
      var self = this;

      if (oldRequirements) {
        for (var i = 0; i < self.current_requirements.length; i++) {
          var requirement = {
            objects: [],
            requirement_query: false,
            requirement_range: false,
            requirement_email: false,
            requirement_birthday: false,
            requirement_register: false,
            requirement_redemption: false,
            requirement_visit_location: false,
            requirement_date_menu: false,
            requirement_date_menu2: false,
            requirement_characteristic: false,

            selectedOption: "",
            modal: false,
            options: [
              {
                text: "Requerimiento por visitas",
                boolean: "requirement_query",
              },
              {
                text: "Requerimiento por rango",
                boolean: "requirement_range",
              },
              {
                text: "Requerimiento por emails",
                boolean: "requirement_email",
              },
              {
                text: "Requerimiento por registro",
                boolean: "requirement_register",
              },
              {
                text: "Requerimiento por cumpleaños",
                boolean: "requirement_birthday",
              },
              {
                text: "Requerimiento por canje de ofertas",
                boolean: "requirement_redemption",
              },
              {
                text: "Requerimiento por característica de usuario",
                boolean: "requirement_characteristic",
              },
            ],
            query_types: [
              {
                text: "Locación",
                type: "Location",
              },
              {
                text: "Oferta",
                type: "Offer",
              },
            ],
            range_types: [
              {
                text: "Fecha",
                type: "date_time",
              },
              {
                text: "Numero",
                type: "integer",
              },
              {
                text: "Flotante",
                type: "float",
              },
            ],
            range_type_attribute: [
              {
                text: "Fecha de creación de la cuenta",
                attribute: "created_at",
              },
              {
                text: "Edad",
                attribute: "age",
              },
              {
                text: "Modificación de la cuenta",
                attribute: "updated_at",
              },
            ],
            query_attributes: {
              type: "ControllerQuery",
              attribute_json: {
                object_type: "",
                object_id: null,
                description: "",
                times: null,
              },
            },
            range_attributes: {
              type: "RangeQuery",
              attribute_json: {
                lower_bound: null,
                upper_bound: null,
                attribute_type: "",
                description: "",
                class_name: "Client",
                attribute_name: "",
              },
            },
            email_attributes: {
              type: "EmailQuery",
              attribute_json: {
                emails: [],
              },
            },
            register_attributes: {
              type: "RegisterQuery",
              attribute_json: {
                sign_up: "true",
              },
            },
            birthday_attributes: {
              type: "EqualityQuery",
              attribute_json: {
                value: "",
              },
            },
            redemption_attributes: {
              type: "RedemptionQuery",
              attribute_json: {
                object_id: null,
                description: "",
                times: null,
              },
            },
            redemption_offers_options: this.getOffers(),

            characteristic_options: this.myCharacteristicsOptions,
            characteristic_values_options: [],
            characteristic_attributes: {
              type: "CharacteristicQuery",
              segment_value: "",
              attribute_json: {
                characteristic_value: "",
                custom_querry: [0, 1],
                // [{characteristic_id:null,value:null, operator:null}]
              },
            },
          };

          var index = i;
          var temp = requirement;
          temp.id = self.current_requirements[i].id;
          var info = self.current_requirements[i].attributes.attribute_json;

          //new
          if (
            self.current_requirements[index].attributes.type ==
            "ControllerQuery"
          ) {
            temp.requirement_query = true;
            temp.query_attributes.attribute_json = info;
            temp.selectedOption = temp.options[0].text;
          } else if (
            self.current_requirements[index].attributes.type == "RangeQuery"
          ) {
            temp.requirement_range = true;
            info.attribute_name = { attribute: info.attribute_name };
            temp.range_attributes.attribute_json = info;
            temp.selectedOption = temp.options[1].text;
          } else if (
            self.current_requirements[index].attributes.type == "EmailQuery"
          ) {
            temp.requirement_email = true;
            temp.email_attributes.attribute_json = info;
            temp.selectedOption = temp.options[2].text;
          } else if (
            self.current_requirements[index].attributes.type == "RegisterQuery"
          ) {
            temp.requirement_register = true;
            temp.register_attributes.attribute_json = info;
            temp.selectedOption = temp.options[3].text;
          } else if (
            self.current_requirements[index].attributes.type == "EqualityQuery"
          ) {
            temp.requirement_birthday = true;
            temp.birthday_attributes.attribute_json.value =
              self.months[info.value - 1];
            temp.selectedOption = temp.options[4].text;
          } else if (
            self.current_requirements[index].attributes.type ==
            "RedemptionQuery"
          ) {
            temp.requirement_redemption = true;
            temp.redemption_attributes.attribute_json = info;
            temp.selectedOption = temp.options[5].text;
          } else if (
            self.current_requirements[index].attributes.type ==
            "CharacteristicQuery"
          ) {
            temp.requirement_characteristic = true;
            temp.characteristic_attributes.segment_value =
              self.myRequirements[this.myIndexCharacteristic][0].name;
            temp.characteristic_attributes.attribute_json.characteristic_value =
              self.myRequirements[this.myIndexCharacteristic][1].value;
            temp.characteristic_attributes.attribute_json.custom_querry =
              self.myRequirements[this.myIndexCharacteristic][2].ranges;
            temp.selectedOption = temp.options[6].text;
            this.myIndexCharacteristic += 1;
          }
          // cl temp
          self.requirements.push(temp);
          // cl requirements
        }
        this.charged = true;
      } else {
        var requirement = {
          objects: [],
          requirement_query: false,
          requirement_range: false,
          requirement_email: false,
          requirement_birthday: false,
          requirement_register: false,
          requirement_redemption: false,
          requirement_visit_location: false,
          requirement_date_menu: false,
          requirement_date_menu2: false,
          requirement_characteristic: false,

          selectedOption: "",
          modal: false,
          options: [
            {
              text: "Requerimiento por visitas",
              boolean: "requirement_query",
            },
            {
              text: "Requerimiento por rango",
              boolean: "requirement_range",
            },
            {
              text: "Requerimiento por emails",
              boolean: "requirement_email",
            },
            {
              text: "Requerimiento por registro",
              boolean: "requirement_register",
            },
            {
              text: "Requerimiento por cumpleaños",
              boolean: "requirement_birthday",
            },
            {
              text: "Requerimiento por canje de ofertas",
              boolean: "requirement_redemption",
            },
            {
              text: "Requerimiento por característica de usuario",
              boolean: "requirement_characteristic",
            },
          ],
          query_types: [
            {
              text: "Locación",
              type: "Location",
            },
            {
              text: "Oferta",
              type: "Offer",
            },
          ],
          range_types: [
            {
              text: "Fecha",
              type: "date_time",
            },
            {
              text: "Numero",
              type: "integer",
            },
            {
              text: "Flotante",
              type: "float",
            },
          ],
          range_type_attribute: [
            {
              text: "Fecha de creación de la cuenta",
              attribute: "created_at",
            },
            {
              text: "Edad",
              attribute: "age",
            },
            {
              text: "Modificación de la cuenta",
              attribute: "updated_at",
            },
          ],
          query_attributes: {
            type: "ControllerQuery",
            attribute_json: {
              object_type: "",
              object_id: null,
              description: "",
              times: null,
            },
          },
          range_attributes: {
            type: "RangeQuery",
            attribute_json: {
              lower_bound: null,
              upper_bound: null,
              attribute_type: "",
              description: "",
              class_name: "Client",
              attribute_name: "",
            },
          },
          email_attributes: {
            type: "EmailQuery",
            attribute_json: {
              emails: [],
            },
          },
          register_attributes: {
            type: "RegisterQuery",
            attribute_json: {
              sign_up: "true",
            },
          },
          birthday_attributes: {
            type: "EqualityQuery",
            attribute_json: {
              value: "",
            },
          },
          redemption_attributes: {
            type: "RedemptionQuery",
            attribute_json: {
              object_id: null,
              description: "",
              times: null,
            },
          },
          redemption_offers_options: this.getOffers(),

          characteristic_options: this.myCharacteristicsOptions,
          characteristic_values_options: [],
          characteristic_attributes: {
            type: "CharacteristicQuery",
            segment_value: "",
            attribute_json: {
              characteristic_value: "",
              custom_querry: [0, 1],
              // [{characteristic_id:null,value:null, operator:null}]
            },
          },
        };
        this.requirements.push(requirement);
      }
    },
    findObjects(index) {
      if (
        this.requirements[index].query_attributes.attribute_json.object_type
          .type == "Offer"
      ) {
        this.requirements[index].objects = this.getOffers();
      } else if (
        this.requirements[index].query_attributes.attribute_json.object_type
          .type == "Location"
      ) {
        this.requirements[index].objects = this.getLocations();
      } else if (
        this.query_attributes.attribute_json.object_type.type == "Category"
      ) {
        this.requirements[index].objects = this.getCategories();
      } else if (
        this.requirements[index].query_attributes.attribute_json.object_type
          .type == "CharacteristicQuery"
      ) {
        this.requirements[index].objects = this.getCharacteristics();
      }
    },
    editCondition() {
      var vm = this;
      vm.condition.attributes.requirements_attributes = [];
      for (var i = 0; i < vm.requirements.length; i++) {
        if (
          vm.requirements[i].id != null &&
          vm.requirements[i].id != undefined &&
          vm.requirements[i]._destroy != undefined
        ) {
          vm.condition.attributes.requirements_attributes.push(
            vm.requirements[i]
          );
        } else if (
          vm.requirements[i].id != null &&
          vm.requirements[i].id != undefined
        ) {
        } else {
          if (vm.requirements[i].requirement_range) {
            var range_attributes = {
              type: "RangeQuery",
              attribute_json: {
                lower_bound:
                  vm.requirements[i].range_attributes.attribute_json
                    .lower_bound,
                upper_bound:
                  vm.requirements[i].range_attributes.attribute_json
                    .upper_bound,
                attribute_type:
                  vm.requirements[i].range_attributes.attribute_json
                    .attribute_name.attribute == "age"
                    ? "integer"
                    : "date_time",
                description:
                  vm.requirements[i].range_attributes.attribute_json
                    .description,
                class_name: "Client",
                attribute_name:
                  vm.requirements[i].range_attributes.attribute_json
                    .attribute_name.attribute,
              },
            };
            vm.condition.attributes.requirements_attributes.push(
              range_attributes
            );
          }
          if (vm.requirements[i].requirement_query) {
            var query_attributes = vm.requirements[i].query_attributes;
            query_attributes.attribute_json.object_type =
              vm.requirements[
                i
              ].query_attributes.attribute_json.object_type.type;
            query_attributes.attribute_json.object_id =
              vm.requirements[i].query_attributes.attribute_json.object_id.id;
            vm.condition.attributes.requirements_attributes.push(
              query_attributes
            );
          }
          if (vm.requirements[i].requirement_email) {
            var email_attributes = vm.requirements[i].email_attributes;
            var format =
              /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/g.test(
                vm.requirements[i].email_attributes.attribute_json.emails
              );
            if (!format) {
              alert(
                "El formato de los correos no coíncide, por favor revisalo"
              );
              vm.condition.attributes.requirements_attributes = [];
            } else {
              email_attributes.attribute_json.emails = vm.requirements[
                i
              ].email_attributes.attribute_json.emails
                .toLowerCase()
                .replace(/\s/g, "")
                .split(",");
              vm.condition.attributes.requirements_attributes.push(
                email_attributes
              );
            }
          }
          if (vm.requirements[i].requirement_register) {
            var register_attributes = vm.requirements[i].register_attributes;
            vm.condition.attributes.requirements_attributes.push(
              register_attributes
            );
          }
          if (vm.requirements[i].requirement_birthday) {
            var birthday_attributes = vm.requirements[i].birthday_attributes;
            birthday_attributes.attribute_json.value =
              vm.months.indexOf(birthday_attributes.attribute_json.value) + 1;
            // cl birthday_attributes.attribute_json.value
            // cl months
            // cl birthday_attributes
            vm.condition.attributes.requirements_attributes.push(
              birthday_attributes
            );
          }
          if (vm.requirements[i].requirement_redemption) {
            var redemption_attributes =
              vm.requirements[i].redemption_attributes;
            redemption_attributes.attribute_json.object_id =
              vm.requirements[
                i
              ].redemption_attributes.attribute_json.object_id.id;
            vm.condition.attributes.requirements_attributes.push(
              redemption_attributes
            );
          }
          // cl vm.requirements[i].characteristic_attributes.attribute_json
          if (vm.requirements[i].requirement_characteristic) {
            var characteristic_attributes = {};
            if (
              vm.requirements[i].characteristic_attributes.attribute_json
                .characteristic_value_id.id != "0"
            ) {
              characteristic_attributes = {
                type: "CharacteristicQuery",
                attribute_json: {
                  characteristic_id:
                    vm.requirements[i].characteristic_attributes.attribute_json
                      .characteristic_id.id,
                  characteristic_value: {
                    id: vm.requirements[i].characteristic_attributes
                      .attribute_json.characteristic_value_id.id,
                    range:
                      vm.requirements[i].characteristic_attributes
                        .attribute_json.characteristic_value_id.range,
                  },
                },
              };
            } else {
              characteristic_attributes = {
                type: "CharacteristicQuery",
                attribute_json: {
                  characteristic_id:
                    vm.requirements[i].characteristic_attributes.attribute_json
                      .characteristic_id.id,
                  characteristic_value: {
                    id: "0",
                    range: [
                      vm.requirements[i].characteristic_attributes
                        .attribute_json.custom_querry[0],
                      vm.requirements[i].characteristic_attributes
                        .attribute_json.custom_querry[1],
                    ],
                  },
                },
              };
            }
            vm.condition.attributes.requirements_attributes.push(
              characteristic_attributes
            );
          }
        }
      }
      if (this.condition.attributes.requirements_attributes.length > 1) {
        this.condition.attributes.frequent = false;
      } else {
        this.condition.attributes.frequent = true;
      }
      try {
        const data = {company: { id: this.getCompany().id }, condition: this.condition}
        this.$http
          .patch(
            "conditions/" + this.$route.path.split("/")[2],
            { data: this.encrypt(data).toString() },
            {
              headers: {
                "X-Device-ID": this.getDeviceId(),
                Authorization: "Bearer " + this.getUserToken(),
              },
            }
          )
          .then(
            function (response) {
              this.$router.push({ name: "condition" });
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
            },
            function (response) {
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
              if (typeof response.body.errors[0].details != "object") {
                alert(response.body.errors[0].details);
              } else {
                let message = [];
                for (var key in response.body.errors[0].details) {
                  message.push(response.body.errors[0].details[key]);
                }
                alert(message);
              }
            }
          );
      } catch (e) {
        alert(e.message);
      }
    },
    getCharacteristics(options) {
      var self = this;
      if (options != null) {
        var characteristics = [options];
      } else {
        var characteristics = [];
      }
      try {
        const data = { company: { id: this.getCompany().id } };
        this.$http
          .post(
            "segments/company",
            { data: this.encrypt(data).toString() },
            {
              headers: {
                "X-Device-ID": this.getDeviceId(),
                Authorization: "Bearer " + this.getUserToken(),
              },
            }
          )
          .then(
            function (response) {
              let fullCharacteristics = response.body.data;
              fullCharacteristics.forEach(function (item) {
                characteristics.push({
                  id: item.id,
                  name: item.attributes.name,
                });
              });

              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
            },
            function (response) {
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
              if (typeof response.body.errors[0].details != "object") {
                alert(response.body.errors[0].details);
              } else {
                let message = [];
                for (var key in response.body.errors[0].details) {
                  message.push(response.body.errors[0].details[key]);
                }
                alert(message);
              }
            }
          )
          .finally(function () {
            // cl characteristics
            this.myCharacteristicsOptions = characteristics;
          });
      } catch (e) {
        alert(e.message);
      }
    },

    changeBooleanState(index, option) {
      var actual = this.requirements[index][option.boolean];
      this.requirements[index].requirement_query = false;
      this.requirements[index].requirement_range = false;
      this.requirements[index].requirement_email = false;
      this.requirements[index].requirement_birthday = false;
      this.requirements[index].requirement_register = false;
      this.requirements[index].requirement_redemption = false;
      this.requirements[index].requirement_characteristic = false;
      this.requirements[index][option.boolean] = !actual;
      if (!this.requirements[index][option.boolean]) {
        this.requirements[index].selectedOption = "";
      } else {
        this.requirements[index].selectedOption = option.text;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/conditions/Edit_condition.vue